export default "__VITE_ASSET__DwGyIt4A__"